<template>
<div class="chapter">
<div class="inner_page">
<p class="left-1">“<i>A shudder in the loins engenders there<br/>The broken wall, the burning roof and tower<br/>And Agamemnon dead.</i>”</p>
<p class="right"><span><span class="smallcaps">WILLIAM BUTLER YEATS</span></span></p>
<p class="left-1">“<i>Over us looms atrocious history.</i>”</p>
<p class="right"><span><span class="smallcaps">JORGE LUIS BORGES</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?7a635d54